import type { ConsumerAddressFields } from "@jti/evo-client";
import type { CasAddressStored } from "@jti/fe-common";

export const convertEvoAddressToCasAddressStored = (address: ConsumerAddressFields): CasAddressStored => {
  return {
    id: String(address.id),
    street: address.street ?? [],
    country_id: address.country_id ?? "",
    country_code: address.country_id ?? "",
    telephone: address.telephone ?? "",
    postcode: address.postcode ?? "",
    city: address.city ?? "",
    firstname: address.firstname ?? "",
    lastname: address.lastname ?? "",
    default_shipping: Boolean(address.default_shipping),
    default_billing: Boolean(address.default_billing),
    administrative_area_level_2: address.administrative_area_level_2 ?? "",
    sublocality_level_2: address.sublocality_level_2 ?? "",
    building_number: address.building_number ?? "",
    district: address.district ?? "",
    neighborhood: address.neighborhood ?? "",
    premise: address.premise ?? "",
    landmark: address.landmark ?? "",
    short_address: address.short_address ?? "",
    extension_attributes: {
      subscription: Boolean(address.extension_attributes?.subscription),
    },
    region: address.region ?? {
      region_id: 0,
      region_code: null,
      region: null,
    },
  };
};
